"use client";
import React from 'react';
import { motion } from 'framer-motion';
import YoutubeMobile from './YoutubeMobile';
import YoutubeDesktop from './YoutubeDesktop';
import { youtubes } from '../../data';

type YoutubeType = {
    title: string;
    description: string;
    link: string;
    src: string;
    color: string;
};


export default function Youtube() {

    return (
        <motion.section id="youtube" className="bg-smoke h-full flex items-center md:bg-transparent ">
            <YoutubeMobile youtubes={youtubes} />
            <div className="flex md:h-fit md:py-24 relative lg:py-24 overflow-hidden">
                <div className='hidden md:block'>
                    <YoutubeDesktop youtubes={youtubes} />
                </div>
            </div>
        </motion.section>
    );
}
